import { render, staticRenderFns } from "./TransferRecord.vue?vue&type=template&id=86fd90ba&scoped=true"
import script from "./TransferRecord.vue?vue&type=script&lang=js"
export * from "./TransferRecord.vue?vue&type=script&lang=js"
import style0 from "./TransferRecord.vue?vue&type=style&index=0&id=86fd90ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fd90ba",
  null
  
)

export default component.exports